/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// store
import {
	setCityData,
	setActivityFacilityData,
	getPrefferedApi,
} from "../../../configureStore";

//components
import AjaxSelect from "../selects/AjaxSelect";
import LocationBtn from "../location-btn";
import Modal from "react-modal";
import Accordion from "react-bootstrap/Accordion";
import SearchBtn from "../searchBtn";
import PrefferedList from "./prefferedList";
Modal.setAppElement("#root");
const SearchModal = (props) => {
	const dispatch = useDispatch();
	const global = useSelector((state) => state.global);
	const searchData = useSelector((state) => state.searchData);
	const activities = useSelector((state) => state.initialData.activityModel);
	const modalData = useSelector((state) => state.modalData);
	const [prefferedFetch] =
		getPrefferedApi.endpoints.fetchPrefferedData.useLazyQuery();
	const [modalIsOpen, setIsOpen] = useState(false);
	const [activityFacilityValue, setActivityFacitlityValue] = useState({
		name: searchData.activityFacility.name,
		value: searchData.activityFacility.value,
		inverted: false,
	});
	const [cityValue, setCityValue] = useState({
		name: searchData.city.name,
		value: searchData.city.value,
		inverted: false,
	});

	useEffect(() => {
		if (props.toggleModal) {
			openModal();
		}
	}, [props.toggleModal]);
	useEffect(() => {
		if (cityValue.inverted) {
			dispatch(setCityData({ name: cityValue.name, value: "" }));
		} else {
			dispatch(setCityData({ name: cityValue.name, value: cityValue.value }));
		}
	}, [cityValue]);
	useEffect(() => {
		dispatch(
			setActivityFacilityData({
				name: activityFacilityValue.name,
				value: activityFacilityValue.value,
			}),
		);
	}, [activityFacilityValue]);
	useEffect(() => {
		if (!props.hasFilters && props.toggleModal) {
			setCityValue((prevState) => ({
				...prevState,
				name: "",
				value: "",
				inverted: false,
			}));
			setActivityFacitlityValue((prevState) => ({
				...prevState,
				name: "",
				value: "",
				inverted: false,
			}));
		}
	}, [props.hasFilters, props.toggleModal]);

	const openModal = async () => {
		setIsOpen(true);
		props.callback();
		dispatch(
			setCityData({ name: searchData.city.name, value: searchData.city.value }),
		);
		dispatch(
			setActivityFacilityData({
				name: searchData.activityFacility.name,
				value: searchData.activityFacility.value,
			}),
		);
		const response = await prefferedFetch(global.url);
		if (response.isError) {
			console.error(response.endpointName + response.error);
		}
	};

	const closeModal = () => {
		setIsOpen(false);
	};
	const prepareSearch = () => {
		props.startSearch();
		setIsOpen(false);
	};
	const clearAll = async () => {
		await setCityValue((prevState) => ({
			...prevState,
			name: "",
			value: "",
			inverted: false,
		}));
		await setActivityFacitlityValue((prevState) => ({
			...prevState,
			name: "",
			value: "",
			inverted: false,
		}));
		props.startSearch();
	};
	return (
		<div>
			<Modal
				portalClassName={"modal-app modal-app--grey"}
				overlayClassName={"modal-app__overlay"}
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				className="modal-app__wrapper"
				contentLabel="search modal">
				<div className="modal-app__header">
					<button
						className="modal-app__close"
						aria-label="close"
						onClick={closeModal}>
						<div className="icon">
							<img
								src="/assets/images/close.svg"
								alt="icon"
							/>
						</div>
					</button>
				</div>
				<div className="modal-app__cont">
					<Accordion>
						<Accordion.Item eventKey="0">
							<Accordion.Header>
								{global.localization.mobileSearchCity}
								{searchData.city.name !== null &&
								searchData.city.name !== "" ? (
									<span>
										:&nbsp;<strong>{searchData.city.name}</strong>
									</span>
								) : null}
							</Accordion.Header>
							<Accordion.Body>
								<div className="search-c__control-nested">
									<LocationBtn
										searchData={searchData}
										url={global.url}
									/>
									<AjaxSelect
										id={"city"}
										placeholder={global.localization.searchCityPlaceholder}
										defaultInputValue={
											searchData.city.value !== "" ? searchData.city.value : ""
										}
										name={
											searchData.city.name !== "" ? searchData.city.name : ""
										}
										inverted={cityValue.inverted}
										localization={global.localization}
										resultsType="city"
									/>
								</div>
								<PrefferedList
									list={
										Object.keys(modalData.prefferedCities).length
											? modalData.prefferedCities
											: []
									}
									staticText={
										searchData.locationChecked
											? {
													text: global.localization.yourLocation,
											  }
											: null
									}
									callback={setCityValue}
								/>
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey="1">
							<Accordion.Header>
								{global.localization.mobileSearchActivityFacility}
								{searchData.activityFacility.name !== null &&
								searchData.activityFacility.name !== "" ? (
									<span>
										:&nbsp;
										<strong>{searchData.activityFacility.name}</strong>
									</span>
								) : null}
							</Accordion.Header>
							<Accordion.Body>
								<AjaxSelect
									id={"facility-activity"}
									placeholder={
										global.localization.searchActivityFacilityPlaceholder
									}
									defaultInputValue={
										activityFacilityValue.value !== ""
											? activityFacilityValue.value
											: ""
									}
									name={
										activityFacilityValue.name !== ""
											? activityFacilityValue.name
											: ""
									}
									inverted={false}
									localization={global.localization}
									resultsType="activityFacility"
								/>
								{activities.trendingActivities.length ? (
									<PrefferedList
										list={activities.trendingActivities}
										callback={setActivityFacitlityValue}
									/>
								) : null}
							</Accordion.Body>
						</Accordion.Item>
					</Accordion>
				</div>
				<div className="modal-app__footer">
					<div className="button-row button-row--sb">
						<div className="button-row__list">
							<button
								className="button-link"
								onClick={clearAll}>
								{global.localization.clearAll}
							</button>
							<SearchBtn
								label={global.localization.searchBtn}
								callback={prepareSearch}
							/>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default SearchModal;
